module.exports = __webpack_public_path__ + "static/media/managarmr1.a0c5f34a.jpg";